var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBaselineApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12255_2188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3473 23.0371C18.0408 24.3036 16.6143 24.1036 15.2411 23.5037C13.788 22.8904 12.4548 22.8638 10.9217 23.5037C9.00192 24.3303 7.98871 24.0903 6.84219 23.0371C0.336347 16.3313 1.29623 6.11923 8.68196 5.74594C10.4817 5.83926 11.7349 6.73248 12.7881 6.81247C14.3612 6.49251 15.8677 5.57263 17.5475 5.69261C19.5606 5.85259 21.0804 6.65249 22.0803 8.09231C17.9208 10.5853 18.9073 16.0646 22.7202 17.5978C21.9603 19.5975 20.9737 21.5839 19.334 23.0504L19.3473 23.0371ZM12.6548 5.66595C12.4548 2.69299 14.8678 0.23997 17.6408 0C18.0274 3.43957 14.5212 5.99924 12.6548 5.66595Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12255_2188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselineApple);
export default __webpack_public_path__ + "static/media/ic_baseline-apple.829520308f5f3f5b7767ce17a82b9cb0.svg";
export { ForwardRef as ReactComponent };